"use client";

import { type LocalizedHref, localizePath } from "@workspace/routing";
import useSiteInfo from "./useSiteInfo";

// An unprefixed path ("/", "/games") in the page's language, for components
// that build their own hrefs: "/" stays "/" or becomes "/pt", never "/pt/".
const useLocalizedPath = (path: string): LocalizedHref => {
  const { language, defaultLang } = useSiteInfo();
  return localizePath(path, language, { defaultLang });
};

export default useLocalizedPath;
